import type { TripPathData, TripUrlParams, UrlRoute } from './trip';
import { CabinClassRequest } from '@clients/FlightApi';

export interface FlightPathData extends TripPathData {
    departureFlight: string;
    returnFlight?: string;
    adultCount?: string;
    childCount?: string;
    infantCount?: string;
    cabinClass?: string;
}

export class FlightUrlParams implements TripUrlParams {
    constructor(
        public routes: UrlRoute[],
        public adultCount: number,
        public childCount: number,
        public infantCount: number,
        public cabinClass: CabinClassRequest = CabinClassRequest.All,
        public isStatic: boolean,
        public url?: string
    ) {}

    get origin(): string {
        return this.routes[0]?.origin || '';
    }

    get destination(): string {
        return this.routes[this.routes.length - 1]?.destination || '';
    }

    get departureDate(): Date {
        return this.routes[0]?.departureDate;
    }

    get returnDate(): Date | undefined {
        return this.routes[0]?.returnDate;
    }

    toJSON() {
        return { ...this };
    }
}
